const ApiStatus = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  FORBIDDEN_HCP_ACCOUNT: 18,
  LOCKOUT: 9,
  API_ERROR: 1,
  SESSION_MANAGEMENT_ERROR: 20,
  PATIENT_EXISTS: 2,
  PASSWORD_VALIDATION: 4,
  UNSUPPORTED_COUNTRY: 6,
  WRONG_REGION: 5,
  EMAIL_NOT_FOUND: 13,
  EMAIL_FOUND_ACTIVATED: 11,
  EMAIL_FOUND_NOT_ACTIVATED: 12,
  DATE_OF_BIRTH_INVALID: 14,
  DATE_OF_BIRTH_VALID: 15,
  PHONE_NOT_FOUND: 17,
  PHONE_CODE_INVALID: 19,
  ALREADY_SENT_INVITE_TO_CLINIC: 21,
} as const;

export default ApiStatus;
